import React, { useEffect, useState } from 'react';
import { Table, Row, Col, Divider, Descriptions, Card, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { creditNoteService, invoiceReceiptService } from '../../../../../services';

const { Title } = Typography;

const InvoiceReceiptPDF = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState([])
    const [data, setData] = useState([])
    const [total, setTotal] = useState(null)
    const [loading, setLoading] = useState(true)

    const columns = [
        {
            title: 'S.No',
            dataIndex: 'sno',
            key: 'sno',
            render: (text, record, index) => index + 1
        },
        {
            title: 'Tracking Number',
            dataIndex: 'name',
            key: 'name',
            // render: (text) => `Invoice# ${text}`
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Amount (USD)',
            dataIndex: 'amount',
            key: 'amount',
            // width: 250,
            render: (text) => `$${text.toLocaleString()}.00`
        },
    ];

    const handlePrint = () => {
        window.print();
    }
    // const handlePrint = () => {
    //     const printContents = document.getElementById('printableArea').innerHTML;
    //     const originalContents = document.body.innerHTML;
    //     document.body.innerHTML = printContents;
    //     window.print();
    //     document.body.innerHTML = originalContents;
    //     window.location.reload();
    //     navigate('/accounts/receipt-collects');
    // };

    const initialize = async () => {
        setLoading(true)
        const { success, data } = await invoiceReceiptService.view(id)
        setLoading(false)

        if (success) {
            const ledger = data.ledger.map((l) => ({
                ...l,
                name: `Invoice # ${l.invoice_id}`
            }))
            const advance = data.advance_payments.map((l) => ({
                ...l,
                name: `Advance # ${l.id}`
            }))

            const tableData = [...ledger, ...advance]
            setTotal(tableData.reduce((sum, table) => sum + parseFloat(table.amount || 0), 0))
            setFormData(data)
            setData(tableData)
        }
    }

    useEffect(() => {
        initialize();
        const beforePrint = () => {
            console.log('Printing...');
        };

        const afterPrint = () => {
            navigate('/accounts/receipt-collects');
        };

        window.addEventListener('beforeprint', beforePrint);
        window.addEventListener('afterprint', afterPrint);

        if (!loading) { handlePrint() };

        return () => {
            window.removeEventListener('beforeprint', beforePrint);
            window.removeEventListener('afterprint', afterPrint);
        };
    }, [loading]);

    return (
        <div style={{ display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: 'center', height: 'auto', width: "auto", backgroundColor: 'transparent', fontSize: '18px' }}>
            <Card id="printableArea" style={{ width: '100%', padding: 20 }}>
                <Row>
                    <Col span={12}>
                        <img src="/images/ctrade-logo.png" alt="Ctrade Logo" style={{ width: 120, height: 70, marginBottom: 20 }} />
                        <Title level={1} style={{ fontSize: '30px' }} >CTRADE USA INC</Title>
                    </Col>
                    <Col span={12}>
                        <div style={{ textAlign: 'right', fontSize: 18, lineHeight: 0.7 }}>
                            <p>3902 SWINGLE RD</p>
                            <p>HOUSTON, TX 77047</p>
                            <p>UNITED STATES</p>
                            <p>Mobile: +1 832-819-2622</p>
                            <p>Email: trade@ctrade.us</p>
                        </div>
                    </Col>
                </Row>
                <Row style={{ marginTop: "20px" }}>
                    <Col span={24} style={{ textAlign: "right", fontSize: 30 }}>
                        <div>
                            <p><strong>Receipt Number:</strong> {formData?.receipt?.id}</p>
                        </div>
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid #B83D3D' }} />
                <Row gutter={20}>
                    <Col span={12}>
                        <Descriptions bordered column={2} layout='vertical'>
                            <Descriptions.Item label={<strong style={{ fontSize: 15 }}>Receipt To:</strong>}>
                                <span style={{ fontSize: 15 }}>
                                    {formData?.customer?.name} <br />
                                    {formData?.customer?.address} <br />
                                    {formData?.customer?.city} <br />
                                    {formData?.customer?.country} <br />
                                    {formData?.customer?.phone}
                                </span>
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                    <Col span={12}>
                        <Descriptions bordered column={1}>
                            <Descriptions.Item label={<strong style={{ fontSize: 15 }}>Payment Received Date: </strong>}>
                                <span style={{ fontSize: 15 }}>{formData?.receipt?.payment_date}</span>
                            </Descriptions.Item>
                            <Descriptions.Item label={<strong style={{ fontSize: 15 }}>Reference Number: </strong>}>
                                <span style={{ fontSize: 15 }}>{formData?.receipt?.reference_number}</span>
                            </Descriptions.Item>
                            <Descriptions.Item label={<strong style={{ fontSize: 15 }}>Receipt Date: </strong>}>
                                <span style={{ fontSize: 15 }}>{formData?.receipt?.receipt_date}</span>
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid #B83D3D' }} />
                <Row style={{ marginTop: 30 }}>
                    <Col span={24}>
                        <Table
                            className="custom-table"
                            columns={columns}
                            dataSource={data}
                            pagination={false}
                            rowKey="id"
                            bordered
                            summary={() => (
                                <Table.Summary.Row style={{ fontSize: "18px", backgroundColor: "#B83D3D", color: "#FFFFFF" }}>
                                    <Table.Summary.Cell colSpan={2}></Table.Summary.Cell>
                                    <Table.Summary.Cell colSpan={1}><strong>Amount Paid:</strong></Table.Summary.Cell>
                                    <Table.Summary.Cell><strong>${total?.toLocaleString()}.00</strong></Table.Summary.Cell>
                                </Table.Summary.Row>
                            )}
                        />
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid #B83D3D' }} />
                <Row>
                    <Col span={24} style={{ textAlign: "center", color: '#E0D7D4' }}>
                        <p>THANK YOU FOR DOING BUSINESS WIITH C TRADE USA INC.</p>
                    </Col>
                </Row>
            </Card>
        </div>
    );
};

export default InvoiceReceiptPDF;
